/**
 * ContentSkeleton — restrained, branded in-shell placeholder shown while
 * auth / launch config / route data resolve. Never a full-page blank or a
 * generic "Loading…". Renders inside the already-visible Vanturis shell so
 * the frame appears immediately and content fills in without a layout jump.
 */
export default function ContentSkeleton({ testid = "content-skeleton" }) {
  return (
    <div className="container-editorial py-16" data-testid={testid} aria-busy="true" aria-live="polite">
      <div className="animate-pulse space-y-6">
        <div className="h-3 w-28 bg-ink/10 rounded" />
        <div className="h-9 w-2/3 max-w-xl bg-ink/10 rounded" />
        <div className="h-4 w-1/2 max-w-md bg-ink/5 rounded" />
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 pt-4">
          {[0, 1, 2].map((i) => (
            <div key={i} className="h-40 bg-ink/5 border border-ivory-400 rounded" />
          ))}
        </div>
      </div>
      <span className="sr-only">Loading Vanturis…</span>
    </div>
  );
}
